export default "__VITE_ASSET__BmttfT_Z__"